import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {endpoints} from '../endpoints';
import {lastValueFrom} from 'rxjs';
import {deleteAllCookies} from '../../helpers/cookie.helper';
import {Router} from '@angular/router';
import {LoginRoot} from '../../models/login.model';
import {getFromStorage} from '../../helpers/session-storage.helper';
import {AuthService} from '../auth/auth-service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {
  }

  login(username: string, password: string, visitorId: string) {
    const url = endpoints.loginEndpoint;
    const body = {username, password, fingerprint: visitorId};

    return lastValueFrom(this.http.post<LoginRoot>(url, body));
  }

  logout() {
    const url = endpoints.logoutEndpoint;

    // Always clear local session and navigate to login, regardless of server response
    return lastValueFrom(this.http.get(url)).then(
      () => {
        this.clearAllSessionData();
        this.router.navigate(['login']);
      }
    ).catch(() => {
      // In case logout endpoint fails (e.g., 403 due to expired token), still perform client-side logout
      this.clearAllSessionData();
      this.router.navigate(['login']);
    });
  }

  async refreshSession() {
    const url = endpoints.refreshEndpoint;
    const refreshToken = getFromStorage('auth-refresh-token');
    return lastValueFrom(this.http.post<LoginRoot>(url, {refresh: refreshToken}));
  }

  clearAllSessionData() {
    this.authService.isAuthenticated.set(false);
    localStorage.clear();
    sessionStorage.clear();
    deleteAllCookies();
  }

  getLogoBasedOnUrl() {
    const url = window.location.href;

    if (url.includes('areacontabile')) {
      return '/images/logo-desksite-test.png';
    }
    else if (url.includes('fatturapoint')) {
      return '/images/logo-fatturaPoint.png';
    }
    return '/images/logo-desksite-prod.png';
  }
}
